import React, {useState} from 'react';
import {Icon} from '@/components/atoms';

const SidebarMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((state) => !state);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <nav
        data-testid='side-menu'
        className={`shadow-lg absolute z-10 flex h-full flex-col bg-layer-01 ${isOpen ? 'w-64' : 'w-20'}`}>
        {!isOpen && (
          <button
            type='button'
            className='mb-4 flex h-14 w-full cursor-pointer items-center border-0 bg-transparent p-0 pl-8'
            title='Open menu'
            aria-label='Open menu'
            onClick={toggleMenu}>
            <Icon
              icon={'menu'}
              className='text-text-primary hover:text-text-black'
            />
          </button>
        )}
        {isOpen && (
          <div
            className='mb-4 flex h-14 w-full items-center pl-8 pr-4'
            title='Close menu'>
            <button
              type='button'
              className='cursor-pointer border-0 bg-transparent p-0 text-text-primary hover:text-text-black'
              aria-label='Close menu'
              onClick={closeMenu}>
              <Icon icon={'menu'} size='medium' />
            </button>
            <button
              type='button'
              className='cursor-pointer border-0 bg-transparent p-0 pl-4 text-text-primary hover:text-text-black'
              onClick={closeMenu}>
              Menu
            </button>
          </div>
        )}
      </nav>
      {isOpen && (
        <button
          type='button'
          className='absolute z-[9] h-screen w-screen cursor-default border-0 bg-gray-400/60 p-0'
          aria-label='Close menu'
          onClick={closeMenu}
        />
      )}
    </>
  );
};

export default React.memo(SidebarMenu);
